import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createApplication } from '@aviv-unified-frontend/runtime/lifecycle';
import { createLogger } from '@aviv-unified-frontend/runtime/monitoring';
import Head from '@/components/Head';
import { useI18n } from '@/hooks/useI18n';
import { Brand } from './brands';
import { FsboGeneric } from './components/pages/fsbo/generic';
import { BrandConfigurationProvider } from './contexts/brandConfiguration/provider';
export const App = () => {
    useI18n('dflp');
    return (_jsxs(BrandConfigurationProvider, { value: Brand, children: [_jsx(Head, { page: "genericFsbo" }), _jsx(FsboGeneric, {})] }));
};
export default createApplication({
    id: 'app_fsbo_depositFunnelLandingFsboGeneric',
    Component: App,
    logger: createLogger({
        name: 'app_fsbo_depositFunnelLandingFsboGeneric',
        version: 1,
    }),
});
